// ============================================
// Chat Module - Event Handlers (ES6)
// onclick 핸들러를 이벤트 리스너로 처리
// ============================================

import {
  closeChatOverlay
} from './overlay.js';

import { toggleMemoryPanel } from '../memory.js';

import {
  filterChats,
  toggleShowHidden
} from './list.js';

import {
  closeRoomActionModal,
  toggleHideChat,
  confirmDeleteFromModal
} from './actions.js';

import {
  showWorldInfoModal
} from './load.js';

import {
  closeModal
} from './user-note.js';

import {
  toggleChoicePopup,
  continueStory,
  openEditMessageModal,
  regenerateLastResponse,
  generateSceneImage
} from './message-actions.js';

import { initRecommendedQuestions } from './recommended-questions.js';

import { showTokenInfoModal } from './token-info.js';

import {
  sendMessage
} from './send.js';

import {
  openModelSelector,
  closeModelSelector
} from './model-selector.js';

import { openChatSettingsModal } from '../settings/index.js';

import {
  showImageModal
} from './load.js';

import { openProfileSelector } from '../profile/index.js';

// ============================================
// 이벤트 리스너 초기화
// ============================================

export function initChatEvents() {
  // 채팅 오버레이 닫기 버튼
  const backBtn = document.querySelector('#chatOverlay .back-btn');
  if (backBtn) {
    backBtn.addEventListener('click', closeChatOverlay);
  }

  // 월드 정보 버튼
  const worldInfoBtn = document.getElementById('worldInfoBtn');
  if (worldInfoBtn) {
    worldInfoBtn.addEventListener('click', showWorldInfoModal);
  }

  // 메모리 패널 토글 버튼들
  document.querySelectorAll('#chatOverlay .header-icon-btn').forEach((btn, index) => {
    if (index === 0) {
      // 첫 번째: 메모리 패널
      btn.addEventListener('click', toggleMemoryPanel);
    } else if (index === 1) {
      // 두 번째: 채팅 설정
      btn.addEventListener('click', openChatSettingsModal);
    }
  });

  // 모델 선택 버튼
  const modelSelectorBtn = document.getElementById('modelSelectorBtn');
  if (modelSelectorBtn) {
    modelSelectorBtn.addEventListener('click', openModelSelector);
  }

  // 프로필 선택 버튼
  const profileSelectBtn = document.querySelector('.profile-select-btn');
  if (profileSelectBtn) {
    profileSelectBtn.addEventListener('click', openProfileSelector);
  }

  // 추천 답변 토글 버튼
  const choiceToggleBtn = document.getElementById('choiceToggleBtn');
  if (choiceToggleBtn) {
    choiceToggleBtn.addEventListener('click', toggleChoicePopup);
  }

  // 추천 질문 초기화
  initRecommendedQuestions();

  // 전송 버튼
  const sendBtn = document.getElementById('sendBtn');
  if (sendBtn) {
    sendBtn.addEventListener('click', () => sendMessage());
  }

  // 메모리 패널 닫기 버튼
  const closePanelBtn = document.querySelector('.close-panel-btn');
  if (closePanelBtn) {
    closePanelBtn.addEventListener('click', toggleMemoryPanel);
  }

  // 채팅 액션 모달 백드롭
  const chatActionBackdrop = document.querySelector('#chatActionModal .bottom-sheet-backdrop');
  if (chatActionBackdrop) {
    chatActionBackdrop.addEventListener('click', closeRoomActionModal);
  }

  // 채팅 액션 버튼들
  const hideActionBtn = document.querySelector('#chatActionModal .chat-action-btn:not(.danger)');
  if (hideActionBtn) {
    hideActionBtn.addEventListener('click', toggleHideChat);
  }

  const deleteActionBtn = document.querySelector('#chatActionModal .chat-action-btn.danger');
  if (deleteActionBtn) {
    deleteActionBtn.addEventListener('click', confirmDeleteFromModal);
  }

  // World Info 모달 닫기 버튼
  const worldInfoClose = document.querySelector('#worldInfoModal .modal-close');
  if (worldInfoClose) {
    worldInfoClose.addEventListener('click', () => {
      closeModal('worldInfoModal');
    });
  }

  // 모델 선택 백드롭
  const modelSelectorBackdrop = document.querySelector('#modelSelectorSheet .bottom-sheet-backdrop');
  if (modelSelectorBackdrop) {
    modelSelectorBackdrop.addEventListener('click', closeModelSelector);
  }

  // 채팅 목록 필터 버튼들
  document.querySelectorAll('.chats-filter-btn[data-chat-filter]').forEach(btn => {
    btn.addEventListener('click', () => {
      const filter = btn.dataset.chatFilter;
      if (filter) filterChats(filter);
    });
  });

  // 숨긴 채팅 토글 버튼
  const hiddenToggleBtn = document.getElementById('hiddenToggleBtn');
  if (hiddenToggleBtn) {
    hiddenToggleBtn.addEventListener('click', toggleShowHidden);
  }

  // 메시지 컨테이너 이벤트 위임 (동적 요소 처리)
  const messagesContainer = document.getElementById('messagesContainer');
  if (messagesContainer) {
    messagesContainer.addEventListener('click', (e) => {
      const actionEl = e.target.closest('[data-action]');
      if (!actionEl) return;

      const action = actionEl.dataset.action;

      if (action === 'showImage') {
        const url = actionEl.dataset.url;
        const name = actionEl.dataset.name || '이미지';
        showImageModal(url, name);
      } else if (action === 'continueStory') {
        continueStory();
      } else if (action === 'generateSceneImage') {
        const messageDiv = actionEl.closest('.message');
        if (messageDiv) {
          generateSceneImage(messageDiv);
        }
      } else if (action === 'regenerate') {
        regenerateLastResponse();
      } else if (action === 'editMessage') {
        const messageDiv = actionEl.closest('.message');
        if (messageDiv) {
          openEditMessageModal(messageDiv);
        }
      } else if (action === 'showTokenInfo') {
        const messageDiv = actionEl.closest('.message');
        if (messageDiv?.dataset.tokenUsage) {
          try {
            const tokenUsage = JSON.parse(messageDiv.dataset.tokenUsage);
            showTokenInfoModal(tokenUsage);
          } catch (e) {
            console.error('[ChatEvents] 토큰 정보 파싱 실패:', e);
          }
        }
      }
    });
  }

  console.log('[ChatEvents] 이벤트 리스너 초기화 완료');
}

// ============================================
// 모듈 초기화
// ============================================

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initChatEvents);
} else {
  initChatEvents();
}

// ============================================
// window 노출 제거됨 (2026-01-06)
// toggleMemoryPanel은 memory.js에서 import됨
// ============================================

export default { initChatEvents };
